import { TableHead, TableRow, TableCell } from "@mui/material";

interface IProps {
    tableHeaders: string[];
}

export default function ExtractionTablHeader({ tableHeaders }: IProps) {
    return (
        <TableHead>
            <TableRow>
                {tableHeaders.map((header, index) => (
                    <TableCell key={index}>{header}</TableCell>
                ))}
            </TableRow>
        </TableHead>
    )
}